// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/root/workspace/n396200/yc-qy-front-react/src/models/contactModel';
import model_2 from '/root/workspace/n396200/yc-qy-front-react/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'contactModel', model: model_1 },
model_2: { namespace: '@@initialState', model: model_2 },
} as const
